import { get } from "../api";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
function Feedback() {
  const navigate = useNavigate();
  const { data, status } = useQuery({
    queryKey: ["feedback"],
    queryFn: () => get("/feedback"),
  });
  return (
    <div className="w-full border rounded-lg shadow-lg p-4 flex flex-col gap-2">
      {status === "success" &&
        data.map((feedback) => (
          <div key={feedback.feedback_id} className="border p-2 rounded-md">
            <div className="text-md font-semibold">{feedback.name}</div>
            <div className="">{feedback.content}</div>
            <div className="">
              {/*all the order histories have null, to start, 
                should fix at some point*/}
              Order history: [
              <span>
                {feedback.order_history
                  .replace("null,", "")
                  .split(",")
                  .map((order_id, idx, array) => (
                    <span key={`${order_id}-${idx}`}>
                      <button
                        onClick={() => navigate(`/order/${order_id}`)}
                        className="text-blue-600 hover:text-blue-400"
                      >
                        {order_id}
                      </button>
                      {idx < array.length - 1 && <span>, </span>}
                    </span>
                  ))}
              </span>
              ]
            </div>
          </div>
        ))}
    </div>
  );
}
export default Feedback;
